import { FC } from 'react';
import { Spacing } from '../../atoms/spacing/spacing';
import { Typography } from '../../atoms/typography/typography';
import { ImageContainer, List, StyledDiv } from '@taleemabad/dsm/components';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';
import styled from '@emotion/styled';
import { IStudentProfile } from '@taleemabad/db';

const ListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--rk-spacing-xl);
  ${mq(BreakpointSizes.xs)} {
    grid-template-columns: repeat(1, 1fr);
    row-gap: var(--rk-spacing-md);
  }
  margin-top: var(--rk-spacing-md);
`;

interface UserProfileSelectionProps {
  profiles: IStudentProfile[];
  schoolName?: string;
  onProfileSelect: (data: IStudentProfile) => void;
}

export const UserProfileSelection: FC<UserProfileSelectionProps> = ({
  profiles,
  schoolName,
  onProfileSelect,
}) => {
  return (
    <Spacing marginBottom="xxxl">
      {/* <Typography variant="textTitleLarge">Welcome to NIETE</Typography> */}
      {/* <Spacing margin="xl" /> */}

      <StyledDiv flexDirection="column" alignItem="left">
        <ImageContainer src="/assets/school.svg" height="50px" width="50px" />
        <Spacing margin="md" />
        <Typography variant="textBodyMedium">
          We are from your child’s school
        </Typography>
        <Spacing margin="md" />
        <Typography variant="textTitleLarge">{schoolName ?? ''}</Typography>
        <Spacing margin="md" />
        <Typography variant="textBodyMedium">
          Select a child to see their progress.
        </Typography>
      </StyledDiv>
      <Spacing margin="xl" />
      {profiles.map((profile) => (
        <ListContainer key={profile.id}>
          <List
            key={profile.id}
            alignment="center"
            heading={profile.name ?? ''}
            supportingText={
              profile.schoolClass?.grade?.label ?? 'Grade Three - A'
            }
            leadingIcon={{
              direction: 'leading',
              source: 'more_vert',
              name: profile.name,
              type: 'monogram',
              isUpperCase: true,
            }}
            trailingIcon={{
              direction: 'trailing',
              source: 'keyboard_arrow_right',
              name: 'keyboard_arrow_right',
              type: 'icon',
            }}
            onClick={() => {
              onProfileSelect?.(profile);
            }}
          />
        </ListContainer>
      ))}
    </Spacing>
  );
};
